import { rgba } from 'polished';
import styled from 'styled-components';

import { colors, fonts, spacing } from '~/utils/css-mixins';
import media, { breakpoints } from '~/utils/media';

export const WysiwygContent = styled.div`
  max-width: ${spacing.siteContentWidth};
  font-size: 14px;
  line-height: 1.6429;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    + p {
      margin-top: 0;
    }
  }

  h1,
  h2 {
    font-family: ${fonts.secondary};
    font-weight: 600;
    font-size: 20px;
    line-height: 1.4;
  }

  h3 {
    font-size: 18px;
    line-height: 1.3;
  }

  h4 {
    font-size: 17px;
    line-height: 1.25;
    margin-bottom: 5px;
  }

  h5,
  h6 {
    font-size: 16px;
    line-height: 1.25;
  }

  a {
    border-bottom: dotted 1px ${rgba(colors.link, 0.5)};
    padding-bottom: 1px;
    font-weight: 600;

    &:focus,
    &:hover {
      border-bottom-style: solid;
      padding-bottom: 3px;
      color: ${colors.linkactive};
    }
  }

  ol,
  ul {
    padding-left: 0;
    list-style: none;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  li {
    margin: 0.5rem 0;
    padding-left: 1.25rem;
    position: relative;
    line-height: 20px;
  }

  ol > li {
    counter-increment: item;

    &::before {
      width: 1rem;
      position: absolute;
      left: -4px;
      top: 0;
      color: ${colors.bluelight};
      font-weight: 600;
      content: counter(item) '. ';
      text-align: center;
    }
  }

  ul > li {
    &::before {
      height: 6px;
      width: 6px;
      content: '';
      position: absolute;
      top: 10px;
      top: calc(0.75em - 3px);
      left: 0;
      background-color: ${colors.bluelight};
      border-radius: 50%;
    }

    li {
      &::before {
        border: solid 1px ${colors.bluelight};
        background-color: white;
      }
    }
  }

  ol,
  ul,
  p {
    + h1,
    + h2,
    + h3,
    + h4,
    + h5,
    + h6 {
      margin-top: 1.5rem;
    }
  }

  blockquote {
    margin: 1.5rem 0;
    padding-left: 1rem;
    color: ${colors.orange};
    font-size: 21px;
    font-weight: 600;

    &::before,
    &::after {
      font-size: 2rem;
      content: '\\201C';
    }

    &::after {
      content: '\\201D';
    }

    > * {
      display: inline;
    }
  }

  .full-width {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  figure {
    margin: 0;

    img {
      max-width: 100%;
      height: auto;
      display: block;
    }

    &.image-style-side {
      float: right;
      margin-left: 20px;
      max-width: 40%;
      margin-bottom: 0.25rem;
    }
  }

  figcaption {
    margin-top: 0.5rem;
    font-size: 14px;
    line-height: 1.5;
    color: ${colors.textmeta};
  }

  ${media.max(breakpoints.phone)`
  
    figure {
      
      img {
        max-width: 100%;
        height: auto;
        display: block;
      }
      &.image-style-side {
        float: none;
        margin-left: 0;
        max-width: 100%;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
      }
    }

  `}

  ${media.tablet`
  
    font-size: 16px;

    h1,
    h2 {
      font-size: 22px;
    }

    li {
      line-height: 24px;
    }

    ol,
    ul,
    p {
      + h1,
      + h2,
      + h3,
      + h4,
      + h5,
      + h6 {
        margin-top: 2rem;
      }
    }

    blockquote {
      margin-top: 2rem;
      margin-bottom: 2rem;
      padding-left: 1.5rem;
      font-size: 24px;
    }
  `}

  ${media.desktop`
    ol,
    ul,
    p {
      + h1,
      + h2,
      + h3,
      + h4,
      + h5,
      + h6 {
        margin-top: 2.5rem;
      }
    }

    blockquote {
      margin-top: 2.5rem;
      margin-bottom: 2.5rem;
      padding-left: 2rem;
    }
  `}
`;
